'use client'
import {useRouter} from 'next/navigation'

const ManageCookies = () => {
  const router = useRouter()

  const onCookiesClear = () => {
    if (typeof window !== 'undefined') localStorage.removeItem('cookie-consent')
    router.refresh()
  }

  return (
    <div onClick={onCookiesClear} className="underline text-body-xs hover:cursor-pointer">
      Manage Settings
    </div>
  )
}

export default ManageCookies
